'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _view = require('./view.code');

var _view2 = _interopRequireDefault(_view);

var _util = require('./util');

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Command = function (_PureComponent) {
  _inherits(Command, _PureComponent);

  function Command() {
    _classCallCheck(this, Command);

    return _possibleConstructorReturn(this, (Command.__proto__ || Object.getPrototypeOf(Command)).apply(this, arguments));
  }

  _createClass(Command, [{
    key: 'renderContent',
    value: function renderContent(snapshotItem) {
      switch (snapshotItem.type) {
        case 'Effect':
          return _react2.default.createElement(
            'dl',
            null,
            _react2.default.createElement(
              'dt',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Effect'
              )
            ),
            _react2.default.createElement(
              'dd',
              null,
              _react2.default.createElement(_view2.default, { isExpanded: true, json: snapshotItem.effect })
            ),
            _react2.default.createElement(
              'dt',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Result'
              )
            ),
            _react2.default.createElement(
              'dd',
              null,
              _react2.default.createElement(_view2.default, { isExpanded: true, json: snapshotItem.result })
            )
          );
        case 'Commit':
          return _react2.default.createElement(_view2.default, { isExpanded: true, json: snapshotItem.commit });
        case 'GetState':
          return _react2.default.createElement(_view2.default, { isExpanded: true, json: snapshotItem.state });
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'title is-5 tag ' + Util.snapshotItemClassName(this.props.snapshotItem);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: className },
          Util.snapshotItemTitle(this.props.snapshotItem)
        ),
        this.renderContent(this.props.snapshotItem)
      );
    }
  }]);

  return Command;
}(_react.PureComponent);

exports.default = Command;


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/view.command.js
 ** module id = 397
 ** module chunks = 0
 **/